/*
 * This file contains all constants related to Should Cost Library
 */

export const KPI_Card_Header_Label = {
  model: 'Model',
  country: 'Manufacturing Country',
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
}

export const KPI_Card_Header_Label_Plural = {
  model: 'Models',
  country: 'Manufacturing Countries',
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
}

export const Should_Cost_Library_Filter_Label = {
  l1: 'L1',
  l2: 'L2',
  l3: 'L3',
  country: 'Country of Origin',
}

export const Should_Cost_Library_Initial_State = {
  summaryFiltersData: {
    l1: '',
    l2: '',
    l3: '',
    country: '',
    filtersLoading: false,
  },
  kpi: {
    kpiData: {},
    kpiLoader: false,
  },
}

export const Model_Meta_Data_Initial_State = {
  modelMetaDataLoader: false,
  modelMetaData: {
    modelName: '',
    modelDescription: '',
    manufacturingCountry: '',
    l1: '',
    l2: '',
    l3: '',
    specifications: [],
    attachments: [],
    creationDate: '',
  },
  modelMetaDataError: '',
}

export const Model_Creation_Approach = {
  top_down: 'Top Down',
  bottom_up: 'Bottom Up',
  derived: 'Derived',
}

export const Model_Status = {
  COMPLETED: 'Completed',
  INPROGRESS: 'In progress',
  NEW: 'New',
}

export const Trendline_Chart_Colors = {
  PO_TRENDLINE: '#118DFF',
  SHOULD_COST_TRENDLINE: '#E66C37',
  PO_SC_TRENDLINE: '#77B0BE',
}

export const Should_Cost_Library_Messages = {
  Confirm_Delete_Should_Cost:
    'This action will delete selected model and its attachments completely. Click confirm if you would wish to proceed!',
  Delete_Model_Error: 'Failed to delete should cost model',
  Get_Model_MetaData_Error: 'Failed to retrieve model meta data',
  Drag_Drop: 'Click component from left panel to create custom breakdown',
  Select_Sub_Component: 'Select a component to add',
  Select_Sub_Component1: 'its subcomponent.',
  Create_Model_Success: 'Should cost model is created successfully',
  Save_As_Draft_Model_Success: 'Should cost model is saved as draft successfully',
  Create_Model_Error: 'Failed to create should cost model',
  Save_As_Draft_Model_Error: 'Failed to save should cost model as draft',
  Update_Model_Success: 'Should cost model is updated successfully',
  Update_Model_Error: 'Failed to update should cost model',
  Preview_Download_Model_Error: 'Failed to download preview should cost model',
  Trendline_Error:
    'Unable to generate Should Cost Trend. Please verify if complete breakdown is added and commodities are attached!',
  BOM_Table_Error: 'Unable to generate BOM Table.',
  Waterfall_Chart_Error: 'Unable to generate Waterfall Chart.',
  Import_Breakdown_Warning_Message:
    'This action will replace all your previous changes for breakdown. Confirm if you would like to proceed.',
  No_Data_Found_Message: 'No Models Found',
  AddComponentMessage: 'Add component’s breakdown from left',
  AddComponentMessage1: 'panel to create custom Model.',
}

export const Should_Cost_Model_Actions = {
  Create: 'create',
  Edit: 'edit',
  Copy: 'copy',
  Draft: 'draft',
}

export const Should_Cost_Component_Title = {
  Should_Cost_Library: 'Should Cost Library',
  View_Should_Cost: 'View Should Cost Model',
  Create_Model: 'Create Should Cost Model',
  Edit_Model: 'Edit Should Cost Model',
  Edit_Model_Button: 'Edit Model',
  Save_Model_Button: 'Save Model',
  Create_Model_Button: 'Create Model',
  Copy_Model_Button: 'Copy this Model',
  Cost_Trend: 'Cost Trend',
  Should_Cost_Trend: 'Cost Trend',
  Breakdown_Details: 'Breakdown Details',
  Delete_Should_Cost: 'Delete Should Cost Model',
  Top_Down_Approach: 'Top down approach',
  Bottoms_Up_Approach: 'Bottom up approach',
  Upload_Should_Cost: 'Upload should cost',
  Select_Creation_Approach: 'Create Should Cost Model',
  Select_Approach_Modal_Title: 'Select approach to create new Should Cost Model',
  Top_Down_Approach_Label: 'Top Down Approach',
  Bottom_Up_Approach_Label: 'Bottom Up Approach',
  Custom_Model_Title: 'Custom Model',
  Upload_Excel_Title: 'Upload Excel',
  Import_From_Library_Title: 'Import from Library',
  GenAI_Drawer_Title: 'Generate Breakdown Using Gen AI',
  Import_Model: 'Import Breakdown',
  Search_Product_Label: 'Search Product',
  Manufacturing_Country_Label: 'Manufacturing Country',
  Generate_Breakdown_Label: 'Generate',
  Cost_Breakdown_Table_Title: 'Cost Breakdown',
  Import_Existing_Drawer_Title: 'Use Existing Model',
  Import_Breakdown_Warning_Title: 'Replace Existing Breakdown',
  Save_Draft: 'Save as Draft',
  Download_Should_Cost: 'Should Cost',
  Preview_Model_Breakdown: 'Preview Model',
  Title_Bottom_Up_Approach: 'Bottom Up',
  Title_Top_Down_Approach: 'Top Down',
  Title_Copy_Model_Action: 'Copy',
}

export const Should_Cost_Component_Description = {
  Select_Creation_Approach_Sub_Title: 'Select an Approach to create a Should Cost Model.',
  Top_Down_Description: 'Define cost as percentage breakdowns for a quick, high-level estimate.',
  Top_Down_Custom_Model_Description:
    'Build a model from scratch by adding indices and defining % breakdowns.',
  Top_Down_Upload_Excel_Description: 'Start with a model created offline and modify it as needed.',
  Top_Down_Import_Library_Description:
    'Start with an existing model from the library and adjust as needed.',
  Bottoms_Up_Description:
    'Add actual values for each component to get precise and detailed calculations.',
  Upload_Should_Cost_Description:
    'Create Should Cost Using Galorath OR Complex Template by Uploading XL File.',
  GenAI_Drawer_Description:
    'Enter products details below to generate Should Cost breakdown using Gen AI.',
  Search_Product_Placeholder: 'Search Products and Categories',
  No_Breakdown_Message: 'No Breakdown To Show',
  Import_Existing_Drawer_Description:
    'Select from models below and import breakdown to create should cost model',
  GEN_AI_Breakdown_Loader_Description: 'Generated Breakdown will appear here',
  Custom_Model_AI_Banner_Message: 'AI-assisted creation and editing',
  Please_Try_Again: 'Something went wrong. Please try again',
}

export const COST_LABELS = ['Raw Material', 'Labor', 'Packaging', 'Freight Cost']

export const SUBCOMPONENT_REQUIRED_SECTION_IDS = [1, 3, 5, 7]

export const COST_COMPONENT_ORDER = {
  'Raw Material': 1,
  Conversion: 2,
  Labor: 3,
  Packaging: 4,
  'Overhead & Margin': 5,
  Logistics: 6,
  'Duty & Tariff': 7,
}
